import Swiper from 'swiper';
import { Pagination, Scrollbar } from 'swiper/modules';

let sliderId;
const sliders = document.querySelectorAll('.teaser-slider');

const kkTeaserSlider = function() {
    sliders.forEach((sliderEl) => {
        const sliderId = sliderEl.getAttribute("data-slider-id");
        const sliderSelector = `#slider-${sliderId}`;
        const navigationSelector = `#navigation-${sliderId}`;
        const prevEl = document.querySelector(`${navigationSelector} .swiper-button-prev`);
        const nextEl = document.querySelector(`${navigationSelector} .swiper-button-next`);
        // console.log(prevEl, nextEl);

        new Swiper(sliderSelector, {
            modules: [Pagination, Scrollbar],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
                draggable: true,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.0875,
                    spaceBetween: 24,
                },
                768: {
                    slidesPerView: 2.0675,
                    spaceBetween: 24,
                },
                1280: {
                    slidesPerView: 3.0675,
                    spaceBetween: 24,
                },
                1600: {
                    slidesPerView: 4,
                    spaceBetween: 32,
                    scrollbar: {
                        hide: true,
                    },
                },
            },
        });
    });
};

export { kkTeaserSlider };
